export const AI_TOOLS = {
    chat_gpt: 'ChatGPT',
    perplexity: 'Perplexity AI',
    gemini: 'Gemini',
    google_ai_overview: 'Google AI Overview',
    google_ai_mode: 'Google AI Mode',
    // grok: 'Grok',
};
